import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import { mapGetters } from 'vuex';
import axios from 'axios';
import { apiMixin } from '@/mixins/api';

export const toothMixin = {
    data() {
        return {
        }
    },
    mixins: [apiMixin],
    computed: {
        ...mapGetters([
            'GET_initParamsToken',
        ]),
    },
    methods: {
        /**
         * Request the segmentation fix API
         * @param {Object} payload - The payload object
         * @param {string} payload.base64Image - Base64 da imagem da regiao na imagem com possivel segmentacao
         * @returns {Promise<{ pts: Array<{ x: number, y: number }> }>} Lista de pontos da segmentacao do dente detectado
         * @throws {Error} If the request fails
         */
        async requestSegmentationFixApi(payload) {
            try {
                const response = await this.requestApi('detect-teeth-segmentation', {
                    request: {
                        'base64_image': payload.base64Image,
                    }
                });

                return {
                    pts: response.data?.found_teeth[0]?.contour_pts || []
                };
            } catch (error) {
                console.error('requestSegmentationFixApiError: ', error);
                evtBus.$emit('evt_toast_show', {
                    title: 'Falha ao detectar a segmentacao dos dentes',
                    description: error.message,
                    variant: 'error',
                    hideDelay: 6000,
                });
            }

            return {
                pts: []
            };
        }
    }
}